import { lazy, Suspense, type ComponentProps } from 'react';
import type { CanvasEditor as CanvasEditorType } from './CanvasEditor';

/**
 * A vaszon-szerkeszto KESOBB TOLTODIK BE (K2, 4. csomag).
 *
 * A kozos szerkesztes motorja (Yjs, a TipTap egyuttmukodes-kiegeszitoi) nagy,
 * es csak az kell neki, aki vasznat nyit. Az elso megnyitas utan mar a
 * bongeszo tarolja.
 */
const CanvasEditor = lazy(() =>
  import('./CanvasEditor').then((module) => ({ default: module.CanvasEditor })),
);

export function LazyCanvasEditor(props: ComponentProps<typeof CanvasEditorType>) {
  return (
    <Suspense fallback={<p className="p-4 text-sm text-ink-muted">Vászon betöltése…</p>}>
      <CanvasEditor {...props} />
    </Suspense>
  );
}
